import { componentProvider } from 'js-component-framework/es';
import { Tablist } from 'aria-components';

/**
 * TabList component.
 *
 * @param  {HTMLElement} options.element  The tab list wrapper.
 * @param  {array}       options.children Array of child elements defined by the config.
 * @param  {object}      options.options  Arbritrary object of options.
 */
function tablistController({ element, children, options }) {
    const { tabs, panels } = children;

    if (null == tabs || null == panels) {
        return;
    }

    this.tablist = new Tablist({ tabs, panels });
}

const tabListConfig = {
    name: 'tab-list',
    component: tablistController,
    querySelector: {
        tabs: '.tabs__list',
    },
    querySelectorAll: {
        panels: '.tabs__panel',
    },
};

componentProvider(tabListConfig);
